import React, { Suspense } from 'react';
import PropTypes from 'prop-types';

/**
 * @prop {Element} feature - Feature que será carregada
 * @prop {Element} fallback - Fallback
 * @prop {Default} default - Componente que será exibido caso não exista feature
 * @prop {*} props - All others props passed
 */

const ToggleComponent = ({
  feature: Feature,
  fallback: Fallback,
  default: Default,
  ...props
}) => {
  if (Feature) {
    return (
      <Suspense fallback={Fallback ? <Fallback /> : <div />}>
        <Feature {...props} />
      </Suspense>
    );
  }
  return Default && <Default {...props} />;
};

ToggleComponent.propTypes = {
  feature: PropTypes.object,
  fallback: PropTypes.object,
  default: PropTypes.object,
};
export default ToggleComponent;
